const data = {
	"width": 24,
	"height": 24,
	"hidden": true,
	"body": "<path fill=\"currentColor\" d=\"M2 8.4A5.4 5.4 0 0 1 7.5 3A5.991 5.991 0 0 1 12 5a5.991 5.991 0 0 1 4.5-2A5.4 5.4 0 0 1 22 8.4c0 5.356-6.379 9.4-10 12.6C8.387 17.773 2 13.76 2 8.4Z\"/>"
};
exports.__esModule = true;
exports.default = data;
